var _defs, _rect, _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHandshakes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 240",
    width: 320,
    height: 240,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "g",
    width: 24,
    height: 24,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 24 0 L 0 0 0 24",
    stroke: "#fff",
    strokeOpacity: 0.17,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "gm",
    cx: "50%",
    cy: "50%",
    r: "60%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#fff",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "62%",
    stopColor: "#fff",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("mask", {
    id: "gmask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#gm)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5082ef",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#5082ef",
    stopOpacity: 0.028
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5082ef",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 240,
    fill: "url(#g)",
    mask: "url(#gmask)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 120,
    r: 42,
    fill: "none",
    stroke: "#4a4a55",
    strokeWidth: 1,
    strokeOpacity: 0.45,
    strokeDasharray: "3 5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 120,
    r: 76,
    fill: "none",
    stroke: "#4a4a55",
    strokeWidth: 1,
    strokeOpacity: 0.45,
    strokeDasharray: "3 5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 120,
    r: 110,
    fill: "none",
    stroke: "#4a4a55",
    strokeWidth: 1,
    strokeOpacity: 0.45,
    strokeDasharray: "3 5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 120,
    x2: 182.3,
    y2: 84.4,
    stroke: "#5a5a66",
    strokeWidth: 1.5,
    strokeOpacity: 0.9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 120,
    x2: 192.2,
    y2: 147,
    stroke: "#5a5a66",
    strokeWidth: 1.5,
    strokeOpacity: 0.9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 120,
    x2: 118.9,
    y2: 128.7,
    stroke: "#5a5a66",
    strokeWidth: 1.5,
    strokeOpacity: 0.9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 182.3,
    y1: 84.4,
    x2: 152.1,
    y2: 44.4,
    stroke: "#3a3a44",
    strokeWidth: 1.3,
    strokeOpacity: 0.75
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 192.2,
    y1: 147,
    x2: 233.1,
    y2: 99.1,
    stroke: "#3a3a44",
    strokeWidth: 1.3,
    strokeOpacity: 0.75
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 118.9,
    y1: 128.7,
    x2: 180.9,
    y2: 193.1,
    stroke: "#3a3a44",
    strokeWidth: 1.3,
    strokeOpacity: 0.75
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 182.3,
    y1: 84.4,
    x2: 101.8,
    y2: 168.9,
    stroke: "#3a3a44",
    strokeWidth: 1.3,
    strokeOpacity: 0.75
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 192.2,
    y1: 147,
    x2: 91.7,
    y2: 86.7,
    stroke: "#3a3a44",
    strokeWidth: 1.3,
    strokeOpacity: 0.75
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 152.1,
    y1: 44.4,
    x2: 98.5,
    y2: 28.8,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.5
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 233.1,
    y1: 99.1,
    x2: 227.7,
    y2: 33.3,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.5
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 180.9,
    y1: 193.1,
    x2: 267.6,
    y2: 142.9,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 101.8,
    y1: 168.9,
    x2: 148.5,
    y2: 229.4,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 91.7,
    y1: 86.7,
    x2: 56.6,
    y2: 157.6,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 152.1,
    y1: 44.4,
    x2: 92.3,
    y2: 33.3,
    stroke: "#3a3a44",
    strokeWidth: 1.2,
    strokeOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 120,
    r: 46,
    fill: "url(#glow)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 98.5,
    cy: 28.8,
    r: 7,
    fill: "#33333c",
    stroke: "#4a4a55",
    strokeWidth: 1.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.7,
    cy: 33.3,
    r: 7,
    fill: "#33333c",
    stroke: "#4a4a55",
    strokeWidth: 1.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 267.6,
    cy: 142.9,
    r: 7,
    fill: "#33333c",
    stroke: "#4a4a55",
    strokeWidth: 1.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.5,
    cy: 229.4,
    r: 7,
    fill: "#33333c",
    stroke: "#4a4a55",
    strokeWidth: 1.2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.6,
    cy: 157.6,
    r: 7,
    fill: "#33333c",
    stroke: "#4a4a55",
    strokeWidth: 1.2
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.3,
    cy: 33.3,
    r: 7,
    fill: "#33333c",
    stroke: "#4a4a55",
    strokeWidth: 1.2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.1,
    cy: 44.4,
    r: 7,
    fill: "#3b3b45",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.1,
    cy: 99.1,
    r: 7,
    fill: "#3b3b45",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 180.9,
    cy: 193.1,
    r: 7,
    fill: "#3b3b45",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.8,
    cy: 168.9,
    r: 7,
    fill: "#3b3b45",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.7,
    cy: 86.7,
    r: 7,
    fill: "#3b3b45",
    stroke: "#5a5a66",
    strokeWidth: 1.2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 182.3,
    cy: 84.4,
    r: 7,
    fill: "#7c6cf0",
    stroke: "#7c6cf0",
    strokeWidth: 1.2
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 192.2,
    cy: 147,
    r: 7,
    fill: "#7c6cf0",
    stroke: "#7c6cf0",
    strokeWidth: 1.2
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.9,
    cy: 128.7,
    r: 7,
    fill: "#7c6cf0",
    stroke: "#7c6cf0",
    strokeWidth: 1.2
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 120,
    r: 13,
    fill: "#5082ef",
    stroke: "#5082ef",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandshakes);
export default __webpack_public_path__ + "static/media/handshakes.9dc57ece0b0ddb680b72329ad7101be8.svg";
export { ForwardRef as ReactComponent };